import { useState } from 'react';
import { Box, Button, Tooltip } from '@mui/material';
import SupportAgentTwoToneIcon from '@mui/icons-material/SupportAgentTwoTone';
import SupportModal from '../../../../components/Modals/SupportModal';

function HeaderButtons() {
  const [supportOpen, setSupportOpen] = useState(false);

  return (
    <Box sx={{ mr: 1 }}>
      <Tooltip title="Contact support" arrow>
        <Button
          size="small"
          variant="outlined"
          startIcon={<SupportAgentTwoToneIcon fontSize="small" />}
          onClick={() => setSupportOpen(true)}
        >
          Support
        </Button>
      </Tooltip>
      <SupportModal open={supportOpen} onClose={() => setSupportOpen(false)} />
    </Box>
  );
}

export default HeaderButtons;
